import { render } from "./DoctorSurveys.vue?vue&type=template&id=bb4e8858"
import script from "./DoctorSurveys.vue?vue&type=script&lang=js"
export * from "./DoctorSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__